module.exports = __webpack_public_path__ + "resources/img/img_magic_sso_m_en.385c50d9ecce75bedaeb55d1aaef8f14.png";